import React, { FC } from 'react';
import { View } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { loadSingleBatch } from '@reducers/batch';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';

interface NCFileDetailsBatchEventsChangeProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const NCFileDetailsBatchEventsChangeComponent: FC<NCFileDetailsBatchEventsChangeProps> = ({
  getProductionBatchByNCFile,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
  loadSingleBatch,
  batch,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    getNCFileById,
    operationsSearch,
    getNCFileByName,
    loadSingleBatch,
  });

  const productionBatchId = batch.data?.productionBatchId;

  return (
    <DetailsPageWrapper title={title.batch}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.CHANGE, productionBatchId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const NCFileDetailsBatchEventsChange = connect(({ batch: { batch } }) => ({ batch }), {
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
  loadSingleBatch,
})(NCFileDetailsBatchEventsChangeComponent);

export { NCFileDetailsBatchEventsChange };
